import validator from 'validator';
import isEmpty from '../utils/isEmpty';

const capitalizeFirst = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const isEmptyValidator = (errors, field, fieldName) => {
  const newField = !isEmpty(field) ? field : '';
  if (validator.isEmpty(newField)) {
    errors[fieldName] = `${capitalizeFirst(fieldName)} field is required`;
  }
  return errors;
};

export default isEmptyValidator;
